import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
  color: {
    type: String,
    default: "#000",
  },
  size: {
    type: Number,
    default: 24,
  },
  name: {
    type: String,
    required: true,
  },
  rotate: {
    type: Number,
    default: 0,
  },
  transition: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props

const src = computed(() => require(`@/assets/icons/${props.name}.svg`));
const style = computed(() => ({
  fontSize: `${props.size}px`,
  maskImage: `url(${src.value})`,
  WebkitMaskImage: `url(${src.value})`,
  background: props.color,
  transform: `rotate(${props.rotate}deg)`,
  transition: props.transition ? "background-color 0.3s" : "none",
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    style: _normalizeStyle(style.value)
  }, null, 4))
}
}

})